/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Faq_Search_PlaceholderInputs */

const tr_faq_search_placeholder = /** @type {(inputs: Faq_Search_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sorularda ara…`)
};

const en_faq_search_placeholder = /** @type {(inputs: Faq_Search_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search questions…`)
};

const de_faq_search_placeholder = /** @type {(inputs: Faq_Search_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In Fragen suchen…`)
};

const ru_faq_search_placeholder = /** @type {(inputs: Faq_Search_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Поиск по вопросам…`)
};

/**
* | output |
* | --- |
* | "Search questions…" |
*
* @param {Faq_Search_PlaceholderInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const faq_search_placeholder = /** @type {((inputs?: Faq_Search_PlaceholderInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Faq_Search_PlaceholderInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_faq_search_placeholder(inputs)
	if (locale === "de") return de_faq_search_placeholder(inputs)
	if (locale === "ru") return ru_faq_search_placeholder(inputs)
	return tr_faq_search_placeholder(inputs)
});